import { render, staticRenderFns } from "./ClientCommercialCard.vue?vue&type=template&id=bccc2ffc&scoped=true"
import script from "./ClientCommercialCard.vue?vue&type=script&lang=js"
export * from "./ClientCommercialCard.vue?vue&type=script&lang=js"
import style0 from "./ClientCommercialCard.vue?vue&type=style&index=0&id=bccc2ffc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc2ffc",
  null
  
)

export default component.exports